// extracted by mini-css-extract-plugin
module.exports = {"newBg":"TrafficMessageRow_newBg_1yq45","missingBg":"TrafficMessageRow_missingBg_23TEW"};